"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconPencil = function SvgIconPencil(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "pencil icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Pencil Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M42.898 15.097l-3.602 3.601a.939.939 0 01-1.328 0l-8.672-8.672a.939.939 0 010-1.328l3.601-3.602a3.758 3.758 0 015.306 0l4.695 4.696a3.744 3.744 0 010 5.305zm-16.696-3.305L5.685 32.308 4.03 41.8c-.227 1.281.89 2.391 2.17 2.172l9.494-1.664L36.21 21.793a.939.939 0 000-1.33l-8.673-8.671a.948.948 0 00-1.335 0zM13.694 30.55a1.089 1.089 0 010-1.546l12.031-12.032a1.089 1.089 0 011.547 0 1.089 1.089 0 010 1.546L15.24 30.55a1.089 1.089 0 01-1.547 0zm-2.821 6.57h3.75v2.837l-5.039.882-2.43-2.429.883-5.04h2.836z"
  }));
};

var _default = SvgIconPencil;
exports.default = _default;